import { CompositeLayer } from '@deck.gl/core';
import GPUGridAggregator from "../utils/gpu-grid-aggregation/gpu-grid-aggregator.js";
import GPUGridLayer from "../gpu-grid-layer/gpu-grid-layer.js";
import CPUGridLayer from "../cpu-grid-layer/cpu-grid-layer.js";
const defaultProps = {
    ...GPUGridLayer.defaultProps,
    ...CPUGridLayer.defaultProps,
    gpuAggregation: false
};
/** Aggregate data into a grid-based heatmap. The color and height of a cell are determined based on the objects it contains. */
export default class GridLayer extends CompositeLayer {
    static { this.layerName = 'GridLayer'; }
    static { this.defaultProps = defaultProps; }
    initializeState() {
        this.state = {
            useGPUAggregation: false // TODO(v9): Re-enable GPU aggregation.
        };
    }
    updateState({ props }) {
        this.setState({
            // TODO(v9): Re-enable GPU aggregation.
            // useGPUAggregation: this.canUseGPUAggregation(props)
            useGPUAggregation: false
        });
    }
    renderLayers() {
        const { data, updateTriggers } = this.props;
        const id = this.state.useGPUAggregation ? 'GPU' : 'CPU';
        const LayerType = this.state.useGPUAggregation
            ? this.getSubLayerClass('GPU', GPUGridLayer)
            : this.getSubLayerClass('CPU', CPUGridLayer);
        return new LayerType(this.props, this.getSubLayerProps({
            id,
            updateTriggers
        }), {
            data
        });
    }
    // Private methods
    canUseGPUAggregation(props) {
        const { gpuAggregation, lowerPercentile, upperPercentile, getColorValue, getElevationValue, colorScaleType } = props;
        if (!gpuAggregation) {
            // cpu aggregation is requested
            return false;
        }
        if (!GPUGridAggregator.isSupported(this.context.device)) {
            return false;
        }
        if (lowerPercentile !== 0 || upperPercentile !== 100) {
            // percentile calculations requires sorting not supported on GPU
            return false;
        }
        if (getColorValue !== null || getElevationValue !== null) {
            // accessor for custom color or elevation calculation is specified
            return false;
        }
        if (colorScaleType === 'quantile' || colorScaleType === 'ordinal') {
            // quantile and ordinal scales are not supported on GPU
            return false;
        }
        return true;
    }
}
